import * as i from 'types';
import styled from 'styled-components';

import { getColor } from 'styles/utils';

export const Heading = styled.h2<HeadingProps>`
  font-family: ${({ theme }) => theme.fonts.baloo};
  font-weight: 800;
  font-size: ${({ size }) => size || '24px'};
  color: ${({ variant }) => getColor(variant || ['blue', 'dark'])};
  margin: ${({ margin }) => margin || '0 auto 32px'};
  text-align: ${({ align }) => align || 'center'};
  line-height: ${({ lineHeight }) => lineHeight || '32px'};
  text-transform: ${({ capitalize }) => capitalize ? 'capitalize' : 'none'};
`;

type HeadingProps = {
  variant?: i.ColorsFromTheme<'white' | 'blue'> | i.SubcolorFromTheme<'blue', 'dark'>;
  margin?: string;
  size?: string;
  lineHeight?: string;
  align?: string;
  capitalize?: boolean;
};
